import * as React from "react"
export const LockIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    viewBox="0 0 43 57.3"
    {...props}
  >
    <defs>
      <path id="a" d="M0 0h43v57.3H0z" />
    </defs>
    <clipPath id="b">
      <use xlinkHref="#a" overflow="visible" />
    </clipPath>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={6}
      d="M40 31.8v22.5H3V23.6h30.4v-9.4h0C33.4 8 28.3 3 22.1 3S10.9 8 10.9 14.3V23M21.5 35.6v4.6"
      clipPath="url(#b)"
    />
  </svg>
)
